import { ErrorLogComponent } from '@cian/error-log-component';
import { setCookie } from '@cian/utils/lib/browser/cookie';
import loadable from '@loadable/component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useMobileAppFullscreenBannerProps } from './useMobileAppFullscreenBannerProps';
import { MOBILE_APP_FULLSCREEN_BANNER_COOKIE_NAME } from '../../constants/cookies';
import { AUD_MOBILE_CLEAN_FIRST_SESSION } from '../../constants/experiments';
import { selectMobileBannerCookieState } from '../../selectors/cookies/selectMobileBannerCookieState';
import { selectExperiments } from '../../selectors/experiments';
import { useApplicationContext } from '../../utils/applicationContext';
import { isExperimentActive } from '../../utils/experiments';

const MobileBannerLoadable = loadable.lib(() => import('@cian/mobile-banner-component'));

export function MobileAppFullscreenBannerContainer() {
  const ctx = useApplicationContext();
  const fullscreenBannerProps = useMobileAppFullscreenBannerProps();
  const mobileBannerShown = useSelector(selectMobileBannerCookieState);

  const experiments = useSelector(selectExperiments);
  const isCleanFirstSessionEnabled = isExperimentActive(experiments, AUD_MOBILE_CLEAN_FIRST_SESSION, 'B');

  if (!fullscreenBannerProps) {
    return null;
  }

  if (isCleanFirstSessionEnabled) {
    if (!mobileBannerShown) {
      setHideBanner();
    }

    return null;
  }

  return (
    <ErrorLogComponent logger={ctx.logger}>
      <MobileBannerLoadable>
        {({ FullscreenBanner }) => <FullscreenBanner {...fullscreenBannerProps} />}
      </MobileBannerLoadable>
    </ErrorLogComponent>
  );
}

function setHideBanner() {
  setCookie(MOBILE_APP_FULLSCREEN_BANNER_COOKIE_NAME, '1');
}
